module.exports = __webpack_public_path__ + "img/icon_2_12.d51a4922.png";